/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Quick_Heron_GazeInputs */

const en_mild_quick_heron_gaze = /** @type {(inputs: Mild_Quick_Heron_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data available`)
};

const de_mild_quick_heron_gaze = /** @type {(inputs: Mild_Quick_Heron_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Daten verfügbar`)
};

/**
* | output |
* | --- |
* | "No data available" |
*
* @param {Mild_Quick_Heron_GazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mild_quick_heron_gaze = /** @type {((inputs?: Mild_Quick_Heron_GazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Quick_Heron_GazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mild_quick_heron_gaze(inputs)
	return de_mild_quick_heron_gaze(inputs)
});